"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ICategory from "@/interfaces/product.category.interfaces";
import categoryService from "@/services/category.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCategoryByIdReturn = RequestsBaseReturn<ICategory | null>;

export type UseGetCategoryByIdProps = ByIdRequestProps;

type UseSwrGetCategoryByIdParams = [string, number];

const useGetCategoryById = ({ _id }: UseGetCategoryByIdProps): UseGetCategoryByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ICategory, Error, UseSwrGetCategoryByIdParams | null>(
    _id ? [SWR_KEYS.getCategoryById, _id] : null,
    ([, categoryId]) => categoryService.getById(categoryId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetCategoryById;
